import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Carolina M.',
  age: 38,
  location: 'New York',
  text: 'El lunes me puse mis jeans favoritos sin pelear con el botón. No lo podía creer, en solo un fin de semana.',
  stars: 5
}, {
  name: 'Valentina R.',
  age: 42,
  location: 'Bogotá',
  text: 'Pensé que era otra dieta más, pero es completamente diferente. Me sentí ligera desde el domingo por la noche.',
  stars: 5
}, {
  name: 'Andrea L.',
  age: 36,
  location: 'Madrid',
  text: 'Lo mejor es que no pasé hambre. Las recetas son fáciles y todo lo encontré en el súper de mi barrio.',
  stars: 5
}, {
  name: 'Gabriela S.',
  age: 44,
  location: 'USA',
  text: 'Perdí 2cm de cintura en 48 horas. Mi esposo me preguntó qué había hecho diferente. ¡Funciona!',
  stars: 5
}, {
  name: 'Lucía P.',
  age: 39,
  location: 'Lima',
  text: 'El café metabólico es mi nuevo favorito. Energía sin esa hinchazón que me daba el café normal.',
  stars: 4
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-229">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`w-4 h-4 ${i < count ? 'text-amber-400 fill-amber-400' : 'text-gray-200 fill-gray-200'}`} data-id="element-230" />)}
    </div>;
}
export function SocialProof() {
  return <section className="py-16 md:py-24 px-6 bg-white/50" data-id="element-231">
      <div className="max-w-4xl mx-auto" data-id="element-232">
        <FadeIn data-id="element-233">
          <div className="text-center mb-12" data-id="element-234">
            <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-3" data-id="element-235">
              Lo que dicen quienes ya lo probaron
            </h2>
            <div className="flex items-center justify-center gap-2" data-id="element-236">
              <StarRating count={5} data-id="element-237" />
              <span className="text-sm text-warmgray font-medium" data-id="element-238">
                4.9 de 5 — basado en +320 reseñas
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-239">
          {reviews.map((review, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-240">
              <div className="bg-cream p-6 rounded-2xl border border-sage/10 h-full flex flex-col" data-id="element-241">
                <StarRating count={review.stars} data-id="element-242" />
                <p className="text-charcoal/80 mt-3 mb-4 leading-relaxed text-sm flex-1 italic" data-id="element-243">
                  "{review.text}"
                </p>
                <div className="flex items-center gap-3 pt-3 border-t border-sage/10" data-id="element-244">
                  <div className="w-9 h-9 rounded-full bg-terracotta/15 flex items-center justify-center" data-id="element-245">
                    <span className="text-terracotta font-bold text-sm" data-id="element-246">
                      {review.name.charAt(0)}
                    </span>
                  </div>
                  <div data-id="element-247">
                    <p className="text-charcoal font-semibold text-sm" data-id="element-248">
                      {review.name}
                    </p>
                    <p className="text-warmgray text-xs" data-id="element-249">
                      {review.age} años · {review.location}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}